<template>
  <v-app id="register" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                 <p class="text-lg-right">
                <v-btn @click="showRegister" color="primary" dark>Se Connecter
               <v-icon dark right>check_circle</v-icon>
                </v-btn>
                </p>
                <div class="layout column align-center">
                  <img src="/static/m.png" alt="Mosala Platform Admin" width="120" height="120">
                  <h1 class="flex my-4 primary--text">Mosala Dashboard</h1>
                </div>                
                <v-form>
                  <v-text-field v-if="!isAdmin" v-show="!isAdmin" append-icon="person" name="login" label="Prénom" type="text" v-model="model.firstName"></v-text-field>
                   <v-text-field v-if="!isAdmin" v-show="!isAdmin" append-icon="person" name="login" label="Nom de famille" type="text" v-model="model.lastName"></v-text-field>
                    <v-text-field v-if="isAdmin" v-show="isAdmin" append-icon="mail" name="mail" label="email" type="text" v-model="model.email"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn icon>
                  <!-- fa fa-facebook-square fa-lg -->
                  <v-icon large color="blue" @click="isAdmin = !isAdmin">{{this.adminIcon}}</v-icon>
                </v-btn>
                <h4 v-show="isAdmin" class="flex my-4 primary--text">Administrateur</h4>
                <h4 v-show="!isAdmin" class="flex my-4 primary--text">Employé</h4>
                <!-- <v-btn icon>
                  <v-icon color="red">fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
export default {
  data: () => ({
    loading: false,
    isAdmin: false,
    model: {
      firstName: "",
      lastName: "",
      email: "",
      password: "password"
    }
  }),
  computed: {
    adminIcon: function() {
      let adminIcon = String;
      adminIcon = this.isAdmin ? "account_circle" : "supervised_user_circle";
      return adminIcon;
    }
  },
  methods: {
    login: function() {
      if (!this.isAdmin) {
        this.model.email =
          this.model.firstName + this.model.lastName + "@mosala.work";
      }
      firebase
        .auth()
        .signInWithEmailAndPassword(this.model.email, this.model.password)
        .then(
          user => {
            this.employee_id = user.uid;
            this.fullName = user.displayName;
            this.bienvenueSnack = true;
            this.loading = true;
            setTimeout(() => {
              this.$router.push("/dashboard");
            }, 1000);
          },
          err => {
            alert(err.message);
          }
        );
    },
    logout:function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          return;
        });
    }

    // login () {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.$router.push('/dashboard');
    //   }, 1000);
    // }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue